var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      !_vm.user || !_vm.user.userdata || !_vm.user.userdata.ID
        ? _c(
            "v-card",
            {
              staticClass: "rounded-lg fill-height",
              attrs: {
                align: "center",
                justify: "center",
                width: "100%",
                color: "transparent",
              },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "fill-height" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "fill-height",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-col", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-h3 font-weight-bold grey--text darken-4 text-center text-uppercase mb-4",
                          },
                          [_vm._v("Log In")]
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "max-width": "500px",
                                  margin: "auto",
                                },
                              },
                              [
                                _vm._v(
                                  "You can log into your account or register a new account."
                                ),
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "my-8",
                                attrs: {
                                  color: "primary",
                                  "x-large": "",
                                  href: _vm.login_url,
                                },
                              },
                              [_vm._v("Log In")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  link: "",
                                  text: "",
                                  color: "primary",
                                  "x-large": "",
                                  href: _vm.registration_url,
                                },
                              },
                              [_vm._v("Register")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.app.show100ms &&
          !_vm.loading &&
          _vm.settings == "" &&
          _vm.user.isAdmin()
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "mt-8",
                  attrs: { cols: "12", sm: "8", "offset-sm": "2" },
                },
                [_c("one-hundred-ms-settings")],
                1
              ),
            ],
            1
          )
        : [
            _c(
              "v-navigation-drawer",
              {
                attrs: { app: "", fixed: "", permanent: "", width: "250" },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c("v-divider"),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              { attrs: { link: "", href: _vm.getLogoutUrl() } },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [_c("v-icon", [_vm._v("mdi-logout")])],
                                  1
                                ),
                                _c("v-list-item-title", [_vm._v("Log Out")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c(
                  "v-list-item",
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "text-h6 py-2" },
                          [_vm._v(" Account Settings ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
                _c(
                  "v-list",
                  { attrs: { nav: "" } },
                  [
                    _c(
                      "v-list-item-group",
                      { attrs: { value: _vm.active_tab, mandatory: "" } },
                      [
                        _vm.user.hasSubscription()
                          ? _c(
                              "v-list-item",
                              {
                                attrs: { value: "rooms" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      path: `/admin/rooms`,
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-monitor-account"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [_c("v-list-item-title", [_vm._v("Rooms")])],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(
                          _vm.menu_items.filter(
                            (item) =>
                              !item.requires_role || _vm.user.hasSubscription()
                          ),
                          function (item) {
                            return _c(
                              "v-list-item",
                              {
                                key: item.tab,
                                attrs: { value: item.tab },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      path: `/admin/${item.tab}`,
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.title)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _c(
                          "v-list-item",
                          {
                            attrs: { value: "settings" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: `/admin/settings`,
                                })
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-cog")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [_c("v-list-item-title", [_vm._v("Settings")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.user.hasRole("administrator")
                          ? _c(
                              "v-list-item",
                              {
                                attrs: { value: "reports" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      path: `/admin/reports`,
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [_c("v-icon", [_vm._v("mdi-chart-bar")])],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v("Reports"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "v-list",
                  { attrs: { nav: "" } },
                  [
                    _c(
                      "v-list-item",
                      {
                        attrs: {
                          link: "",
                          href: _vm.support_url,
                          target: "_blank",
                        },
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("v-icon", [_vm._v("mdi-help-circle")])],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [_c("v-list-item-title", [_vm._v("Support")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-list",
                  { attrs: { nav: "", "two-line": "" } },
                  [
                    _c(
                      "v-list-item",
                      { attrs: { link: "", href: _vm.getAccountUrl() } },
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("v-icon", [_vm._v("mdi-account")])],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [_vm._v("Account")]),
                            _c("v-list-item-subtitle", [
                              _vm._v(_vm._s(_vm.user.userdata.data.user_email)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.user.hasRole("administrator")
                  ? _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.redirectToExternalUrl("/wp-admin/")
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-cog")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Wordpress Admin"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "v-main",
              { staticClass: "custom-main" },
              [
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _vm.active_tab == "reports"
                      ? _c("reports")
                      : _vm.active_tab == "rooms" && !_vm.$route.params.id
                      ? _c("rooms")
                      : _vm.active_tab == "settings"
                      ? _c("settings")
                      : _vm.active_tab == "rooms" && _vm.$route.params.id
                      ? _c("room")
                      : _vm.active_tab == "branding"
                      ? _c("branding")
                      : _vm.active_tab == "recordings"
                      ? _c("recordings")
                      : _vm.active_tab == "roles"
                      ? _c("roles")
                      : _vm.active_tab == "account"
                      ? _c("account")
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }